import styled from 'styled-components';
import { makeStyles } from '@material-ui/core';
import { ColorConstants } from '@shared/constants';

export const useStyles = makeStyles(() => ({
    button: {
        backgroundColor: ColorConstants.FUN_GREEN,
        WebkitTextFillColor: ColorConstants.white,
        height: '32px',
        marginTop: '8px',
        fontSize: '16px',
        '&:hover': {
            backgroundColor: ColorConstants.FUN_GREEN,
            opacity: 0.9,
        },
    },
    inputWrapper: {
        marginBottom: '8px',
    },
    inputLabel: {
        marginBottom: '-1px',
        color: ColorConstants['black-50%'],
    },
    inputField: {
        color: ColorConstants.black,
        '&::placeholder': {
            color: ColorConstants['black-25%'],
        },
    },
    selectWrapper: {
        marginBottom: '8px',
        height: '100%',
        minHeight: '32px',
        '& .select__input': {
            color: ColorConstants.black,
        },
        '& .select__single-value': {
            color: ColorConstants.black,
        },
        '& .select__placeholder': {
            color: ColorConstants['black-25%'],
        },
        '& label': {
            marginTop: '6px',
            color: ColorConstants['black-50%'],
        },
        '& .select__control': {
            width: '215px',
        },
    },
    selectStyle: {
        color: ColorConstants.black,
    },
    textAreaField: {
        color: ColorConstants.black,
        padding: '16px 0',
        '&::placeholder': {
            color: ColorConstants['black-25%'],
        },
    },
    textAreaWrapper: {
        minHeight: '64px',
        marginBottom: '8px',
    },
    textAreaLabel: {
        marginBottom: '0',
        color: ColorConstants['black-50%'],
    },
}));

export const ErrorMessage = styled.p`
    color: ${ColorConstants.salmon};
    min-height: 14px;
    font-size: 12px;
    margin: -8px 0 3px 3px;
    text-align: left;
    font-weight: bold;
`;

export const ClientAndAccountTagsWrapper = styled.div`
    margin-top: 6px;
    margin-bottom: 32px;
`;

export const ButtonWrapper = styled.button`
    border: 0;
    background-color: transparent;
    width: 100%;
    cursor: context-menu;
`;

export const dateRangeStyles = {
    textAlign: 'right',
    zIndex: 1,
};
